<!--
 * @Author: Shber
 * @Date: 2023-04-19 14:30:58
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-29 18:47:27
 * @Description:
-->
<template>
  <div class="temp3">
    <div class="banner">
      <video
        v-show="videoShow && content.video_url"
        ref="videoRef"
        controls
        controlsList="nofullscreen nodownload noplaybackrate"
        class="banner_video"
        x5-playsinline="true"
        playsinline="true"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-video-orientation="portraint"
        :poster="content.news_pic"
      >
        <source :src="content.video_url">
      </video>
      <van-image v-show="!videoShow" class="banner_pic" :src="content.news_pic" fit="cover" @load="loadImage">
        <div v-if="content.video_url && !isPlaying" class="controls_bg">
          <span ref="videoPlay" class="icon_play" @click="onPlay" />
        </div>
      </van-image>
    </div>
    <div class="top_msg">
      <h3 class="fw_bold text_overflow2">{{ content.news_title }}</h3>
      <ul v-if="content.pegs.length" class="tag_list">
        <li v-for="(pag, p) in content.pegs" :key="p"># {{ pag }}</li>
      </ul>
      <div style="clear:both;" />

      <UserBar :user-info="content.users" />

      <div class="content_msg ">
        <div class="wrapper">
          <div ref="textBox" :class="{ 'text': true, 'is_full': !packHide }">
            <label v-show="textFull && packHide" class="pack_down" title="展开" @click="packHide = false"> {{
              $t('articles.text9') }}</label>
            <span ref="textLine" class="text_line">
              {{ content.new_lead }}
            </span>
          </div>
        </div>
        <div v-show="!packHide" class="show_btn">
          <span class="pack_up" title="收起" @click="packHide = true"> {{ $t('articles.text10') }}</span>
        </div>
      </div>
    </div>
    <div class="food_content">
      <div v-for="(item, i) in content.menu" :key="i">
        <h4 class="food_title fw_bold">{{ item.title }}</h4>
        <div class="food_list">
          <div v-for="(dish, f) in item.list" :key="f" class="list_item">
            <span class="index fw_bold">{{ dish.num }}</span>
            <a style="flex:1" class="food_right" :href="goSwiper(dish)">
              <van-image class="food_pic" :src="dish.food.pic" fit="cover" />
              <div class="food_text">
                <h4 class="fw_bold text_overflow2"><i v-if="dish.is_recommend === 1" class="icon_star" /> {{
                  dish.food.food_name }}</h4>
                <p class="text_overflow3">{{ dish.food.jianjie1 }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content.contribution.length" class="user_content">
      <div class="temp_title">
        <p class="fw_bold" title="菜单出品厨师">{{ $t('articles.text1') }}</p> <span title="全部" @click="userPopupShow = true">{{
          $t('goods.text') }}<i class="icon_more" /></span>
      </div>
      <div class="user_scroll">
        <div class="user_list">
          <a
            v-for="user in content.contribution"
            :key="user.uid"
            class="list_item"
            :href="setLink('userview', user.uid)"
            @click="goUser(user.uid)"
          >
            <div class="user">
              <img :src="user.usr_pic" class="user_pic" alt="">
              <img v-if="user.auth_pic" :src="user.auth_pic" class="auth_icon" alt="">
            </div>
            <p class="text_over">{{ user.nick_name }}</p>
          </a>
        </div>
      </div>
    </div>
    <div class="message_info">
      <div class="temp_title">
        <p class="fw_bold" title="详细信息">{{ $t('articles.text2') }}</p>
      </div>
      <div class="message_list">
        <div v-for="(msg, m) in content.detail" :key="m" class="list_item">
          <template v-if="msg.type === 2">
            <h6 class="fw_bold">{{ msg.title }}</h6>
            <p>{{ msg.content.label }}</p>
            <p v-for="(text, t) in msg.content.info" :key="t">
              {{ text.duty }}:
              <template v-if="text.skuid != 0">
                <a :href="text.link" class="a">{{ text.nick_name }} </a>
              </template>
              <template v-else>{{ text.nick_name }}</template>
            </p>
          </template>
          <template v-else-if="msg.type === 4">
            <h6 class="fw_bold">{{ msg.title }}</h6>
            <p>
              <span v-for="(pag, p) in msg.cards" :key="p" class="mr_10">#{{ pag.title }} </span>
            </p>
          </template>
          <template v-else>
            <h6 class="fw_bold">{{ msg.title }}</h6>
            <p>{{ formatTime(msg.content) }}</p>
          </template>
        </div>

      </div>
    </div>
    <div v-if="content.recommends.length" class="recommend_content">
      <div class="temp_title">
        <p class="fw_bold" title="相关推荐">{{ $t('wiki.text7') }}</p> <a title="全部" :href="goRecommends()">{{
          $t('goods.text') }}<i class="icon_more" /></a>
      </div>
      <div class="foods_content">
        <div class="foodList">
          <a
            v-for="(item, index) in content.recommends"
            :key="index"
            class="foodLast fw_bold"
            :href="setLink('foodview', item.id)"
          >
            <SingleFood :data-info="item" :iszan="false" />
          </a>
        </div>
      </div>
    </div>
    <van-popup :show="userPopupShow" overlay-class="user_popup" position="bottom">
      <div class="popups_content">
        <div class="popup_title fw_bold" title="菜单出品厨师">
          {{ $t('articles.text1') }}
          <span class="icon_close" @click="userPopupShow = false" />
        </div>
        <div class="body">
          <ul>
            <li v-for="(user, i) in content.contribution" :key="i">
              <a class="user_pic_box" :href="setLink('userview', user.uid)" @click="goUser(user.uid)">
                <img :src="user.usr_pic" class="usr_pic">
                <img v-if="user.auth_pic" :src="user.auth_pic" class="auth_pic">
              </a>
              <div class="user_text">
                <h4 class="text_over">{{ user.nick_name }}</h4>
                <p class="text_over">{{ user.unit_duty }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script setup>
import '@/style/scss/articles/temp3.scss'
import { Image as VanImage, Popup as VanPopup, Toast } from 'vant'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化

import UserBar from '@/components/UserBar.vue'
import SingleFood from '@/components/singleFood.vue'
import config from '@/config/config'
// import { superLink } from '@/utils'
import { onMounted, ref } from 'vue'
// const emits = defineEmits(['onFinish'])
const { t } = useI18n() // 国际化方法
const router = useRouter()
const query = ref(router.currentRoute.value.query) // 页面id
const packHide = ref(true) // 超长文字展示隐藏
const textFull = ref(false) // 文字是否溢出
const userPopupShow = ref(false) // 厨师弹框
// const textRef = ref(null) // 具体文字
const textBox = ref(null) // 包裹文字盒子
const textLine = ref(null) // 文字高度dom
// const isPackShow = ref(false)
const videoShow = ref(false)
const videoRef = ref(null)
const videoPlay = ref(null)
const isPlaying = ref(false)

const emits = defineEmits(['onFinish'])
const props = defineProps({
  content: { // 内容对象
    type: Object,
    default: () => {
      return {
        pegs: [],
        contribution: [],
        recommends: [],
        users: {},
        detail: {},
        menu: [],
        praiselist: [],
        share: {}
      }
    }
  }
})
onMounted(() => { // 计算文字展开按钮是否展示
  const videoDom = videoRef.value
  if (videoDom) {
    videoDom.addEventListener('play', () => {
      isPlaying.value = true
      console.log('Video is now playing!')
    })
    // videoDom.addEventListener('pause', () => {
    //   isPlaying.value = false
    //   console.log('Video is now pauseing!')
    // })
  }

  const parentHeight = textBox.value.offsetHeight
  const childHeight = textLine.value.offsetHeight
  console.log('textRef', parentHeight, childHeight)
  textFull.value = childHeight > parentHeight // 判断高度，超高了显示‘展开’
})

const loadImage = (value) => {
  emits('onFinish', false)

  setTimeout(() => { // 无奈之举，数据异步进来 dom还没有撑开，所以计算失败
    const parentHeight = textBox.value.offsetHeight
    const childHeight = textLine.value.offsetHeight
    console.log('textRef', parentHeight, childHeight)
    textFull.value = childHeight > parentHeight // 判断高度，超高了显示‘展开’
  })
}

const formatTime = (_time) => {
  const originalDateString = _time
  const date = new Date(originalDateString)
  if (date instanceof Date && !isNaN(date)) { // 判断是字符串类型还是时间类型
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  } else {
    return _time
  }
}

const onPlay = () => {
  const videoDom = videoRef.value
  videoShow.value = true
  if (videoDom) { videoDom.play() }
}
const onPause = () => {
  const videoDom = videoRef.value
  if (videoDom) { videoDom.pause() }
}
const setLink = (_des, _id) => {
  if (_des === 'userview' && _id == '0') { // 如果是自定义用户不跳转
    return 'javascript:;'
  }
  return `${config.webapplink}/${_des}?id=${_id}`
}
const goUser = (_id) => { // 如果是自定义用户，则提示
  if (_id == '0') { return Toast(t('articles.text3')) }
}
const goRecommends = () => {
  return `${config.webapplink}/recommend?id=${query.value.id}&type=1`
}
const goSwiper = (_item) => {
  return `${config.webapplink}/menuswiper?id=${query.value.id}&index=${_item.num}`
  // router.push({ path: '/menuswiper', query: { id: query.value.id, index: 1 }})
}

</script>
